import styled from "styled-components";

const ProductListContainer = styled.div`
    // margin-top: -20px;
    padding-bottom: 20px;
    position: relative;

    .applied-filters {
        padding-top: 10px;
        .filter-item {
            background: #efefef;
            padding: 3px 9px 4px;
            border-radius: 3px;
            margin-bottom: 5px;
            .icon {
            }
        }

        .clear-all {
            margin-top: 3px;
            padding-left: 10px;
        }
    }
`;
export default ProductListContainer;
